import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  containerOutlined: {
    height: 40,
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleOutlined: {
    fontSize: 14,
    lineHeight: 16,
    color: Colors.RedPallete.red,
    fontFamily: 'TCCC-UnityText Bold',
  },
  container: {
    height: 40,
    borderWidth: 1,
    borderColor: Colors.RedPallete.red,
    backgroundColor: Colors.RedPallete.red,
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    fontSize: 14,
    fontFamily: 'TCCC-UnityText Bold',
    lineHeight: 16,
    color: 'white',
  },
  containerDisabled: {
    height: 40,
    borderWidth: 1,
    borderColor: Colors.GrayPallete.lightgrayTwo,
    backgroundColor: Colors.GrayPallete.lightgrayTwo,
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
